import SliderInput from './Slider';
import { useLanguage } from '../../context/LanguageContext';

export default function SliderQuantity({ value, onChange }) {
  const { t } = useLanguage();

  return (
    <SliderInput
      description={[
        `${t('noneBias')}`,
        `${t('fewBias')}`,
        `${t('someBias')}`,
        `${t('mostBias')}`,
        `${t('allBias')}`,
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
